// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"723aaf9a","328":"71460612","369":"9a58be03","453":"83234151","542":"c93d38f4","750":"74482379"}[chunkId] + ".chunk.js";
};